/**
 * Example auth api connector that lets your user log in using a defined payload
 * and returns a promise
 *
 *
 */

import catchErrors from './catchErrors'

export default {
  getRoles(stations) {
    let params = {}
    if (stations) {
      params.stations = stations
    }
    return catchErrors.get(`/v2/newsdesk/roles`, {
      params,
      cache: {
        maxAge: 1000
      }
    })
  },

  getRole(id) {
    return catchErrors.get(`/v2/newsdesk/roles/${id}`)
  },

  createRole(data) {
    return catchErrors.post(`/v2/newsdesk/roles`, data)
  },

  updateRole(id, data) {
    return catchErrors.patch(`/v2/newsdesk/roles/${id}`, data)
  },

  deleteRole(id) {
    return catchErrors.delete(`/v2/newsdesk/roles/${id}`)
  }
}
